module.exports = __webpack_public_path__ + "static/img/5.18d11d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/eng/5.png
// module id = n87o
// module chunks = 0